module.exports = __webpack_public_path__ + "media/packs/images/flags/AL-f6250ec7405b9f8dc8c136cc4e99e8a1.png";